import { render, staticRenderFns } from "./Contactusfinal.vue?vue&type=template&id=844d1e64"
import script from "./Contactusfinal.vue?vue&type=script&lang=js"
export * from "./Contactusfinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports